/* eslint-disable @typescript-eslint/restrict-plus-operands */
import styled from 'styled-components';
import Theme from '../../../styles/models/theme';

export const Container = styled.div<{theme?: any; clear?: boolean}>`
  width: 100%;
  background-color: ${({theme, clear}) =>
    clear ? 'transparent' : theme.white};
  padding: 10px 10px 10px 10px;
  display: flex;
  border-bottom: ${({theme, clear}) =>
    clear ? '0px' : '1px solid ' + theme.grayBorder};
  text-align: center;
  box-shadow: ${({theme, clear}) =>
    clear ? '0px 0px 0px' : '0px 4px 12px' + theme.cardshadow};
  box-sizing: border-box;
  flex-direction: row;
  align-items: center;
`;

export const DateContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const LabelDay = styled.text<{theme?: any}>`
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: ${({theme}) => theme.darkText};
`;

export const LabelMonth = styled.text<{theme?: any}>`
  font-weight: normal;
  font-size: 18px;
  line-height: 16px;
  color: ${({theme}) => theme.darkGrayText};
`;

export const RemittanceContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 9;
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 20px;
  flex: 5;
`;

export const AmountContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 20px;
  align-items: center;
  flex: 4;
`;


export const Name = styled.text<{theme?: any; valueSize?: string}>`
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 13px;
  text-align: left;
  margin-bottom: 5px;
  color: ${({theme}) => theme.secondary};
`;

export const Amount = styled.text<{theme?: any; valueSize?: string}>`
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 13px;
  text-align: left;
  margin-bottom: 5px;
  color: ${({theme}) => theme.secondary};
`;

export const Cancel = styled.text<{theme?: any; valueSize?: string}>`
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  text-align: left;
  color: ${({theme}) => theme.canceled};
`;

export const Pending = styled.text<{theme?: any; valueSize?: string}>`
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  text-align: left;
  color: ${({theme}) => theme.pending};
`;

export const Received = styled.text<{theme?: any; valueSize?: string}>`
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  text-align: left;
  color: ${({theme}) => theme.success};
`;

export const Id = styled.text<{theme?: any; valueSize?: string}>`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  text-align: left;
  color: ${({theme}) => theme.darkGrayText};
`;

export const Button = styled.button<{
    backgroundColor?: string;
    shadowColor?: string;
    disabled?: boolean;
    validation?: boolean;
    theme: Theme;
}>`
  background-color: ${({backgroundColor, theme}) =>
    backgroundColor || theme.primary};
  width: 100%;
  border-radius: 100px;
  padding: 5px;
  justify-content: center;
  opacity: ${({disabled, validation}) => (disabled || (validation != null && !validation) ? 0.5 : 1)};
  border-width: 0px;
  margin-top: 5px;
  z-index: 1;

  &:active {
    transform: scale(0.99);
    opacity: 0.8;
  }
`;

export const ButtonTitle = styled.text<{color?: string; theme: any}>`
  color: ${({color, theme}) => color || theme.lightText};
  text-transform: uppercase;
  font-weight: 400;
  font-size: 10px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
  'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
  sans-serif;
`;
